import { PrivacyLink } from "./PrivacyLink";
import { MobileTermsLink } from "./MobileTermsLink";
import { CookieSettingsLink } from "./CookieSettingsLink";

export const PrivacyFooter = ({ prefix }) => (
  <footer className="border-t border-[#0f0f10]/15 bg-[#faf9f5] text-[#0f0f10]" data-testid={`${prefix}-privacy-footer`}>
    <div className="mx-auto flex max-w-site flex-wrap items-center justify-between gap-5 px-6 py-8 text-xs md:px-10">
      <span data-testid={`${prefix}-privacy-footer-brand`}>© {new Date().getFullYear()} Vitura</span>
      <div className="flex flex-wrap items-center gap-6">
        <a href="mailto:hello@takevitura.com" className="transition-opacity hover:opacity-70" data-testid={`${prefix}-privacy-footer-email`}>hello@takevitura.com</a>
        <PrivacyLink testId={`${prefix}-footer-privacy-link`} />
        <MobileTermsLink testId={`${prefix}-footer-mobile-terms-link`} />
        <CookieSettingsLink testId={`${prefix}-footer-cookie-settings-link`} />
      </div>
    </div>
  </footer>
);